import useFetch from '../../../hooks/useFetch';
import { WarehouseOrderRateFilters } from '../../models/WareHouseOrderRates';
import { EndPoints } from '../EndPoints';
import { ServiceEvents } from '../shared/interfaces';
import { useState } from 'react';

const useWarehouseOrderRatesService = () => {
       const { doGet, doPost, doPut, doDelete } = useFetch();


    const [fetchingGetWarehouseOrderRate, setFetchingGetWarehouseOrderRate] = useState(false);
    const [fetchingGetWarehouseOrderRates, setFetchingGetWarehouseOrderRates] = useState(false);
    const [fetchingShowWarehouseOrderRate, setFetchingShowWarehouseOrderRate] = useState(false);
    const getWarehouseOrderRate = (quoteId: number, events: ServiceEvents = {}) => {
        // doGet({
        //     ...events,
        //     url: EndPoints.WAREHOUSE_QUOTES.GET_WAREHOUSE_RATE.replace(':quote_id', quoteId.toString()),
        //     setFetching: setFetchingGetWarehouseOrderRate
        // });
    };

    const getAllWarehouseOrderRatesByOrder = (
    
        quoteId: number,
        ratesFilters: WarehouseOrderRateFilters,
        events: ServiceEvents = {}

    ) => {
      
        const queryString = Object.entries(ratesFilters)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
        const url = `${EndPoints.WAREHOUSE_ORDERS.GET_ALL_WAREHOUSE_ORDER_RATES}?${queryString}`;
    
      
        doGet({
            ...events,
            url: url.replace(
                ':warehouse_order_id',
                quoteId.toString()
            ),
            setFetching: setFetchingGetWarehouseOrderRates
        });
    };

   
    const showWarehouseOrderRate = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.SHOW_WAREHOUSE_RATE.replace(':id', id.toString()),
            setFetching: setFetchingShowWarehouseOrderRate
        });
    };



   

    return {
        getWarehouseOrderRate,
        getAllWarehouseOrderRatesByOrder,
        showWarehouseOrderRate,
        fetchingGetWarehouseOrderRate,
        fetchingGetWarehouseOrderRates,
        fetchingShowWarehouseOrderRate,
      };
    };


export default useWarehouseOrderRatesService;
